var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiceBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4F4F4F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.59.133a2.184 2.184 0 0 0-2.244 1.62L7.46 5.06l.366-.104a2.746 2.746 0 0 1 3.355 1.939l1.35 5.039 2.006.536a2.184 2.184 0 0 0 2.68-1.548L18.92 4.58a2.185 2.185 0 0 0-1.55-2.683L11.028.199a1.59 1.59 0 0 0-.436-.062V.133zm.063 1.427c.1 0 .198.015.294.042a1.095 1.095 0 1 1-.294-.038V1.56zm4.261 7.373c.099 0 .197.015.292.042a1.094 1.094 0 1 1-.292-.038v-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.406 5.42c-.145 0-.294.042-.44.063L1.624 7.18a2.188 2.188 0 0 0-1.55 2.683l1.7 6.343a2.185 2.185 0 0 0 2.684 1.55l6.34-1.701a2.184 2.184 0 0 0 1.55-2.683l-1.7-6.343a2.184 2.184 0 0 0-2.243-1.62v.01zm-.02 1.428a1.095 1.095 0 1 1-.326.037c.106-.03.216-.044.325-.041v.004zm-5.814 1.56a1.095 1.095 0 1 1-.327.035 1.1 1.1 0 0 1 .327-.041v.006zm3.685 2.129a1.095 1.095 0 1 1-.325.035c.105-.03.215-.044.325-.042v.007zm3.688 2.128a1.094 1.094 0 1 1-.325.035c.106-.03.215-.044.325-.041v.006zM4.13 14.221a1.096 1.096 0 1 1-.327.037c.106-.03.217-.044.327-.041v.004z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceBlack);
export default __webpack_public_path__ + "static/media/diceBlack.df7fffa9d7c2861efcbcd83bce212f74.svg";
export { ForwardRef as ReactComponent };